module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f62b.7f36e544.svg";